<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">
            {{ $t("menu.user") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <router-link :to="{ name: 'user_create' }" class="btn btn-sm">
            <base-button size="md" type="neutral" v-if="isDtacAdmin">{{
              $t("new")
            }}</base-button>
          </router-link>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <h3 class="mb-0">{{ $t("menu.user") }}</h3>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  :placeholder="$t('search')"
                >
                </base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>

              <el-table-column
                min-width="120px"
                align="right"
                :label="$t('user.type')"
              >
                <div slot-scope="{ row }" class="d-flex">
                  {{ getUserType(row.GroupID) }}
                </div>
              </el-table-column>

              <el-table-column
                min-width="80px"
                align="right"
                :label="$t('actions')"
                v-if="isDtacAdmin"
              >
                <div slot-scope="{ $index, row }" class="d-flex">
                  <base-button
                    @click.native="handleEdit($index, row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                    v-if="isDtacAdmin"
                  >
                    <i class="text-dtac-bt fa fa-edit"></i>
                  </base-button>

                  <base-button
                    @click.native="handleDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                    v-if="isDtacAdmin"
                  >
                    <i class="text-dtac-bt fa fa-trash"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            v-if="queriedData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
                <span v-if="selectedRows.length">
                  - &nbsp; &nbsp; {{ selectedRows.length }}
                  {{ $t("row_select") }}
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
    <modal :show.sync="showAddModal" modal-classes="modal-secondary">
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <form
          class="new-event--form"
          @submit.prevent="handleSubmit(handleUpdate)"
        >
          <base-input :label="$t('user.name')" v-model="edit.Name">
          </base-input>

          <base-input
            :label="$t('email')"
            input-classes="form-control-alternative new-event--title"
            v-model="edit.Email"
          >
          </base-input>


          <base-input
            :label="$t('user.phone')"
            input-classes="form-control-alternative new-event--title"
            v-model="edit.Phone"
          >
          </base-input>


          <base-input :label="$t('user.role')">
            <el-select
              v-model="edit.GroupID"
              filterable
              @change="edit.EnterpriseID = ''"
            >
              <el-option
                v-for="option in userGroup"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              >
              </el-option>
            </el-select>
          </base-input>

          <base-input
            :label="$t('menu.corporate')"
            v-if="edit.GroupID == 2 || edit.GroupID == 4"
          >
            <el-select
              v-model="edit.EnterpriseID"
              filterable
              :placeholder="$t('menu.corporate')"
            >
              <el-option
                v-for="option in corporate"
                :key="option.ID"
                :label="option.Name"
                :value="option.ID"
              >
              </el-option>
            </el-select>
          </base-input>

          <input type="hidden" class="new-event--start" />
          <input type="hidden" class="new-event--end" />
        </form>
      </validation-observer>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdate()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PagingUsers/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      propsToSearch: ["name", "email", "mobile"],
      selectedRows: [],
      showAddModal: false,

      edit: {
        Name: "",
        Email: "",
        Phone: "",
        GroupID: "",
        EnterpriseID: ""
      },
      otp: {},
      rowCreate: {},
      userGroup: [
        {
          label: "Dtac Admin",
          value: 3
        },
        {
          label: "Read Only",
          value: 1
        },
        {
          label: "Enterprise Admin",
          value: 2
        },
        {
          label: "Enterprise Super Admin",
          value: 4
        }
      ]
    };
  },

  computed: {
    ...mapGetters({
      isCorporateAdmin: "Auth/isCorporateAdmin",
      isDtacAdmin: "Auth/isDtacAdmin",
      isReadOnly: "Auth/isReadOnly",
      tableData: "Auth/getData",
      corporateRaw: "Corporate/getData"
    }),
    corporate: function() {
      if (this.edit.GroupID == 4) {
        return this.corporateRaw.filter(i => {
          return i.UpperID == 0;
        });
      } else {
        return this.corporateRaw;
      }
    },
    tableColumns: function() {
      return [
        {
          prop: "Name",
          label: this.$t("user.name"),
          minWidth: 100
        },
        {
          prop: "Email",
          label: this.$t("email"),
          minWidth: 100
        },
        {
          prop: "Phone",
          label: this.$t("user.phone")
        },
        {
          prop: "EnterpriseName",
          label: this.$t("menu.corporate")
        }
      ];
    }
  },
  mounted() {
    this.listData();
    this.listCorporate();
  },
  methods: {
    ...mapActions({
      createData: "Auth/createData",
      updateData: "Auth/updateData",
      deleteData: "Auth/deleteData",
      listData: "Auth/listData",
      listCorporate: "Corporate/listData"
    }),
    getUserType(type) {
      let userTypeName = [
        "",
        "Read Only",
        "Enterprise Admin",
        "Dtac Admin",
        "Enterprise Super Admin"
      ];
      return userTypeName[type];
    },
    handleEdit(index, row) {
      this.showAddModal = true;
      this.edit.GroupID = row.GroupID;
      this.edit.ID = row.ID;
      this.edit.Email = row.Email;
      this.edit.Username = row.Username;
      this.edit.Name = row.Name;
      this.edit.Phone = row.Phone;
      this.edit.EnterpriseID = row.EnterpriseID;
    },
    handleUpdate() {
      this.showAddModal = false;
      this.updateData({
        editUserID: this.edit.ID,
        email: this.edit.Email,
        name: this.edit.Name,
        groupID: this.edit.GroupID,
        phone: this.edit.Phone,
        status: 1,
        enterpriseID: this.edit.EnterpriseID
      })
        .then(resp => {
          this.listData();
          swal.fire({
            title: this.$t("edit_success"),
            text: ``,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        })
        .catch(err => {
          swal.fire({
            title: this.$t(err.response.data.Msg),
            text: this.getErrorText(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.Name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.deleteData({
              delUserID: row.ID
            })
              .then(resp => {
                this.listData();
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false
                });
              })
              .catch(err => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false
                });
              });
          }
        });
    },

    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
